import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=7c056a33"
import script from "./ServerError.vue?vue&type=script&lang=js"
export * from "./ServerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports